import Glide from "@glidejs/glide";
import { getUrl } from "functions/BaseAxios";
import React, { FC, useEffect } from "react";
import NcImage from "shared/NcImage/NcImage";
import NextPrev from "shared/NextPrev/NextPrev";
import ncNanoId from "utils/ncNanoId";

export interface GallerySliderProps {
  className?: string;
  galleryImgs?: any[];
  ratioClass?: string;
  status?: string;
}

const GallerySlider: FC<GallerySliderProps> = ({
  className = "",
  galleryImgs = [],
  ratioClass = "aspect-w-4 aspect-h-3",
  status = ''
}) => {
  const UNIQUE_CLASS = "nc_glide2_" + ncNanoId();
  const safeImgs = Array.isArray(galleryImgs) ? galleryImgs : [];

  useEffect(() => {
    if (safeImgs.length > 0) {
      new Glide(`.${UNIQUE_CLASS}`, {
        perView: 1,
        gap: 0,
        keyboard: false,
      }).mount();
    }
  }, []);

  const getImgSrc = (item: any) => {
    if (!item) return "";
    if (typeof item === "string") return item;
    if (item.urls) {
      try {
        const parsed = typeof item.urls === "string" ? JSON.parse(item.urls) : item.urls;
        if (Array.isArray(parsed) && parsed.length > 0) {
          const raw = parsed[4] || parsed[2] || parsed[0] || "";
          return getUrl(raw);
        } else if (typeof parsed === "string") {
          return getUrl(parsed);
        }
      } catch (e) {
        return typeof item.urls === "string" ? getUrl(item.urls) : "";
      }
    }
    if (item.url) return getUrl(item.url);
    return "";
  };

  const renderDots = () => {
    return (
      <div
        className="glide__bullets flex items-center justify-center absolute bottom-2 left-1/2 transform -translate-x-1/2 space-x-1.5"
        data-glide-el="controls[nav]"
      >
        {safeImgs.length > 1 && safeImgs.map((_, i) => (
          <button aria-label={`button ${i}`}
            className="glide__bullet w-1.5 h-1.5 rounded-full bg-neutral-300"
            key={i}
            data-glide-dir={`=${i}`}
          />
        ))}
      </div>
    );
  };

  const renderSliderGallery = () => {
    return (
      <div className={`${UNIQUE_CLASS}  overflow-hidden`}>
        <div className="glide__track" data-glide-el="track">
          <ul className="glide__slides">
            {safeImgs.length > 0 ? safeImgs.map((item, index) => (
              <li key={index} className="glide__slide">
                <div className={ratioClass}>
                  <NcImage style={{ objectFit: 'cover' }} height={100} src={getImgSrc(item)} />
                </div>
              </li>
            )) : (
              <div className={ratioClass}>
              </div>
            )}
          </ul>
        </div>

        {/* DOTS */}
        <div className="absolute -bottom-4 inset-x-0 h-10 from-neutral-900"></div>
        {renderDots()}

        {/* NAV */}
        <div className="absolute opacity-0 group-hover:opacity-100 transition-opacity flex top-1/2 transform -translate-y-1/2 inset-x-2 justify-between ">
          {safeImgs.length > 1 && <NextPrev className="w-full justify-between " btnClassName="w-8 h-8" />}
        </div>
      </div>
    );
  };

  return (
    <div className={`nc-GallerySlider ${className}`} data-nc-id="GallerySlider">
      {renderSliderGallery()}
    </div>
  );
};

export default GallerySlider;
